import axios from 'axios';

const baseURL = import.meta.env.VITE_WEB_API_URL ?? 'http://localhost:4500';

export const api = axios.create({ baseURL });

/**
 * Credentialed client for the participant-access portal (`/access/*`). Sends the
 * httpOnly participant-session cookie so verified participants stay signed in.
 */
export const accessApi = axios.create({ baseURL, withCredentials: true });
